import { render, staticRenderFns } from "./ListGlobalSettingsPage.vue?vue&type=template&id=655fb112"
import script from "./ListGlobalSettingsPage.vue?vue&type=script&lang=js"
export * from "./ListGlobalSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports